import { ProgramAttachment } from '../../types';
import { PlayIcon } from '../../../assets/icons';
import { useAttachmentThumbnail } from '../../hooks/useAttachmentsThumbnail';
import { BoxSpinner } from '../../../commons/components/Spinner';

export const VideoPreview = (props: { programId: string; attachment: ProgramAttachment }) => {
  const { data: url } = useAttachmentThumbnail(props.programId, props.attachment);

  return (
    <>
      {url ? (
        <>
          <img className="carousel__media" src={url} alt="Video" />
          <PlayIcon style={{ position: 'absolute', width: 30, height: 30 }} />
        </>
      ) : (
        <BoxSpinner />
      )}
    </>
  );
};
